export var EFormStep = /*#__PURE__*/function (EFormStep) {
  EFormStep["Form"] = "form";
  EFormStep["Success"] = "success";
  EFormStep["Closed"] = "closed";
  return EFormStep;
}({});